import { useCallback, useRef } from 'react';
import type { RefObject } from 'react';
import { fetchNeedVerify } from '@/lib/service/anonymously';
import { TurnstileModalHandle } from '@/components/TurnstileModal';

type UseTurnstileVerifyResult = {
  turnstileRef: RefObject<TurnstileModalHandle>;
  getTurnstileToken: (needVerify?: boolean) => Promise<string | null>;
};

const useTurnstileVerify = (): UseTurnstileVerifyResult => {
  const turnstileRef = useRef<TurnstileModalHandle>(null);

  const getTurnstileToken = useCallback(async (needVerify?: boolean): Promise<string | null> => {
    let shouldVerify = needVerify;
    if (typeof shouldVerify === 'undefined') {
      const needVerifyRes = await fetchNeedVerify().catch((): null => null);
      shouldVerify = !(needVerifyRes?.code === 0 && needVerifyRes?.data === false);
    }
    if (!shouldVerify) {
      return '';
    }
    const result = await turnstileRef.current?.open();
    if (!result?.success) {
      return null;
    }
    return result.token ?? '';
  }, []);

  return { turnstileRef, getTurnstileToken };
};

export default useTurnstileVerify;
